/* SearchResultPage.styles.ts generated by @compiled/babel-plugin v0.29.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import * as React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { media } from '@atlaskit/primitives';
const _7 = "@media (min-width:64rem){._u5gg1f09{margin-block:var(--ds-space-400) var(--ds-space-200)}}";
const _6 = "._1mou5k6p{margin-block:var(--ds-space-300) var(--ds-space-200)}";
const _5 = "._1p571eps{row-gap:var(--ds-space-100)}";
const _4 = "._1n261g80{flex-wrap:wrap}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1bah1yb4{justify-content:space-between}";
const _ = "._1e0c1txw{display:flex}";
export const GridHeader = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_1e0c1txw _1bah1yb4 _4cvr1h6o _1n261g80 _1p571eps _1mou5k6p _u5gg1f09", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  GridHeader.displayName = 'GridHeader';
}